import React from 'react';
import { Table } from 'react-bootstrap';
import EmployeesTableRow from './EmployeesTableRow.jsx';

const EmployeesTable = ({ employees, onEdit, onDelete }) => {
  const renderData = (data, depth = 0) => {
    return data.map((item, index) => (
      <React.Fragment key={index}>
        <EmployeesTableRow
          employee={item}
          depth={depth}
          onEdit={onEdit}
          onDelete={onDelete}
        />
        {item.children.length > 0 && renderData(item.children, depth + 1)}
      </React.Fragment>
    ));
  };

  return (
    <Table className="table-condensed" hover>
      <thead>
        <tr>
          <th>Employees</th>
          <th>Group</th>
          <th>Location</th>
          <th>Position</th>
          <th>Employee ID</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>{renderData(employees)}</tbody>
    </Table>
  );
};

export default EmployeesTable;
